export const BLOG_POSTS_RESET_STATE = 'BLOG_POSTS_RESET_STATE';
export const BLOG_POSTS_CURRENT_ITEM = 'BLOG_POSTS_CURRENT_ITEM';

export const BLOG_POSTS_REQUEST_LOADING = 'BLOG_POSTS_REQUEST_LOADING';
export const BLOG_POSTS_REQUEST_SUCCESS = 'BLOG_POSTS_REQUEST_SUCCESS';
export const BLOG_POSTS_REQUEST_FAILED = 'BLOG_POSTS_REQUEST_FAILED';

export const BLOG_POSTS_CURRENT_ACTION = 'BLOG_POSTS_CURRENT_ACTION';
export const BLOG_POSTS_RESET_ACTION = 'BLOG_POSTS_RESET_ACTION';